export const openCheckoutPage = (checkoutUrl: string) => {
  try {
    if (!checkoutUrl) {
      /* istanbul ignore next */
      throw new Error(
        `Required parameters missing from native checkout bridge. checkoutUrl: ${checkoutUrl}`
      );
    }
    window?.open(checkoutUrl, "_self");
  } catch (error) {
    console?.log("PAYMENT REDIRECTION FAILED", error);
    /* istanbul ignore next */
    throw error;
  }
};
